import { I18n } from '@app/i18n/strings-keys';
import { GRID_LIST_VIEW_TYPE } from '../ui/xux-grid';

export enum INVENTORY_COUNT_STATUS_VALUE {
  Open = 'open',
  Closed = 'closed',
  Completed = 'completed',
}

export enum INVENTORY_COUNT_STATUS_NAME {
  Open = 'Open',
  Closed = 'Submitted',
  Completed = 'Completed',
}

export enum INVENTORY_COUNT_ITEM_STATUS_VALUE {
  Open = 'open',
  Closed = 'closed',
  Completed = 'completed',
}

export enum INVENTORY_COUNT_ITEM_STATUS_NAME {
  Open = 'Open',
  Closed = 'Submitted',
  Completed = 'Completed',
}

export const INVENTORY_COUNT_STATUS_OPTIONS = [
  {
    text: I18n.Status.Open,
    value: INVENTORY_COUNT_STATUS_VALUE.Open,
  },
  {
    text: I18n.Status.Completed,
    value: INVENTORY_COUNT_STATUS_VALUE.Completed,
  },
];
export const INVENTORY_COUNT_STATUS_ENUM_OPTIONS = Object.freeze({
  [INVENTORY_COUNT_STATUS_VALUE.Open]: I18n.Status.Open,
  [INVENTORY_COUNT_STATUS_VALUE.Completed]: I18n.Status.Completed,
  [INVENTORY_COUNT_STATUS_VALUE.Closed]: I18n.Status.Submitted,
});

export const INVENTORY_COUNT_VIEW_OPTIONS = [
  { text: I18n.Common.CategoryView, value: GRID_LIST_VIEW_TYPE.CATEGORY_VIEW },
  {
    text: I18n.Common.AlphabeticalListView,
    value: GRID_LIST_VIEW_TYPE.ALPHABETICAL_LIST_VIEW,
  },
];

export const INVENTORY_COUNT_ITEM_STATUS_OPTIONS = [
  {
    text: I18n.Status.Open,
    value: INVENTORY_COUNT_ITEM_STATUS_VALUE.Open,
  },
  {
    text: I18n.Status.Submitted,
    value: INVENTORY_COUNT_ITEM_STATUS_VALUE.Closed,
  },
  {
    text: I18n.Status.Completed,
    value: INVENTORY_COUNT_ITEM_STATUS_VALUE.Completed,
  },
];

export enum INVENTORY_COUNT_OVERRIDE_VALUE_TYPES {
  ALL = 'ALL',
  NIL = 'NIL',
}

export enum INVENTORY_COUNT_COST_METHOD {
  MOVING_AVERAGE = 'moving_average',
  LAST_PURCHASE = 'last_purchase',
}

export enum INVENTORY_COUNT_UNIT_NAME {
  BaseUnit = 'Base Unit',
  DefaultTransferUnit = 'Default Transfer Unit',
  DefaultOrderingUnit = 'Default Ordering Unit',
}

export enum INVENTORY_COUNT_UNIT_VALUE {
  BaseUnit = 'base_unit',
  DefaultTransferUnit = 'default_transfer_unit',
  DefaultOrderingUnit = 'default_ordering_unit',
}

export const INVENTORY_COUNT_UNIT_OPTIONS = [
  {
    text: I18n.Forms.GridForm.BaseUnit,
    value: INVENTORY_COUNT_UNIT_VALUE.BaseUnit,
  },
  {
    text: I18n.Forms.InventoryCountForm.DefaultTransferUnit,
    value: INVENTORY_COUNT_UNIT_VALUE.DefaultTransferUnit,
  },
  {
    text: I18n.Forms.InventoryCountForm.DefaultOrderingUnit,
    value: INVENTORY_COUNT_UNIT_VALUE.DefaultOrderingUnit,
  },
];
